<template>
  <div class="switch-map">
    <van-popup v-model="isShowPopup" @close="closePopup">
      <div class="learning-path-view">
        <div class="label-view">
          <div class="line"></div>
          <div class="title">请选择学习地图</div>
        </div>
        <div class="radio-view">
          <van-radio-group v-model="radioChecked" >
            <van-radio v-for="(item, index) in journeyList" :key="index" :name="item.id" :disabled=" item.state == 2 ? true : item.state == 1 ? false : false" checked-color="#fe902e" @click="switchMap">
              {{ item && item.displayName }}
              <img v-if="item.state == 2" class="switch-img" src="../../../assets/images/home/lock.png" />
              <!-- <div v-if="item.state == 1 && item.completionRate > 0">
                {{ item && item.completionRate }}
              </div> -->
            </van-radio>
          </van-radio-group>
          <!-- <van-radio-group v-else v-model="radioChecked" @click="closePopup">
          <van-radio v-for="(item, index) in journeyList" :key="index" :name="item.id" checked-color="#fe902e">{{ item && item.ename }}</van-radio>
        </van-radio-group> -->
        </div>
        <div class="tips-view" v-if="showTips">
          <div class="tips-view-container">
            <div class="tips-img">
              <img src="../../../assets/images/home/Tips_Orange.png" alt="" />
            </div>
            <div class="tips-text">提示：</div>
            <div class="tips-content">未解锁地图的课程可在资料库查看</div>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="close-btn" v-if="show" @click="closePopup">
      <img class="close-btn-img" src="../../../assets/images/home/ic_fork@2x.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwitchMapPopup',
  data() {
    return {
      radioChecked: '',
      isShowPopup: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showTips: {
      type: Boolean,
      default: false
    },
    journeyList: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedMapId: {
      type: String,
      default: ''
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        console.log('🚀 ~ file: SwitchMapPopup.vue:72 ~ handler ~ newValue:', newValue)
        this.isShowPopup = newValue
      },
      deep: true // 深度监听
      // immediate: true
    },
    selectedMapId: {
      handler(newValue, oldValue) {
        this.radioChecked = newValue
      }
      // deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    closePopup() {
      this.isShowPopup = false
      this.$emit('closePopup')
    },
    switchMap() {
      let id = this.radioChecked
      this.$emit('switchMap', id)
    }
  }
}
</script>

<style lang="less" scoped>
.close-btn {
  z-index: 99999;
  position: fixed;
  bottom: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 28px;
  height: 28px;
  .close-btn-img {
    z-index: 99999;
    width: 28px;
    height: 28px;
  }
}
.van-popup--center {
  border-radius: 5px;
}
/deep/ .van-radio {
  margin-bottom: 29px;
}
/deep/ .van-radio__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
}
/deep/ .van-radio__label {
  line-height: normal;
  display: flex !important;
  align-items: center !important;
}
.learning-path-view {
  width: 351px;
  min-height: 300px;
  background: #ffffff;
  border-radius: 5px;
  .label-view {
    display: flex;
    align-items: center;
    padding: 19px 0 14px 0;
    width: calc(100% - 40px);
    margin: 0 20px;
    border-bottom: 1px solid #e4e4e4;
    .line {
      width: 4px;
      height: 12px;
      background: #fe6a23;
      border-radius: 2px;
      margin-right: 7px;
    }
    .title {
      font-size: 15px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      color: #1f333f;
    }
  }
  .radio-view {
    padding: 20px 0 0 20px;
    height: calc(100% - 60px);
    min-height: 200px;
    overflow-y: scroll;
    font-size: 15px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #1f333f;
    .switch-img {
      width: 16px;
      height: 16px;
      margin-left: 6px;
      display: flex;
      align-items: center;
    }
  }
  .tips-view {
    width: 100%;
    height: 47px;
    .tips-view-container {
      width: 319px;
      height: 47px;
      display: flex;
      align-items: center;
      margin-left: 20px;
      // justify-content: center;
      .tips-img {
        width: 14px;
        height: 16px;
        margin-right: 5px;
        img {
          width: 14px;
          height: 16px;
        }
      }
      .tips-text {
        // width: 36px;
        height: 17px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #EB1700;
        line-height: 17px;
      }
      .tips-content {
        height: 17px;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #757575;
        line-height: 17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/SwitchMapPopup.vue